<div [@showHide]="isNotificationReady ? 'show' : 'hide'">
  @if (notification && notification.show) {
  <notification
    [class]="notification.status === 'failure' ? '-colorAccentPink' : '-colorAccentLightBlue'"
    [title]="notification.title"
    [showDismissBtn]="true"
    (dismissNotification)="unsetNotification($event)">
    {{ notification.description }}
  </notification>
  }
</div>
<div class="-docpage-content">
  <div class="-left-pane" [class]="!isDocIndex ? '-full-width' : '-pane-width'">
    @if (body) {
    <content-viewer [content]="body" (docRendered)="handleDocRendered($event)"> </content-viewer>
    }
  </div>
  @if (isDocIndex) {
  <div class="-right-pane">
    @if (docIndexReady) {
    <index [indexContainer]="'content-viewer'" [title]="'On this Page'"></index>
    }
    <contact-block></contact-block>
  </div>
  }
</div>
<related-articles [relatedArticles]="relatedArticles"></related-articles>

@if (requestNowConfirmModal) {
<div>
  <modal [visible]="true" (visibleChange)="closeConfirmModal()" [secondaryModal]="true" [title]="'Not logged in !'">
    <div>
      <p class="-fontSmall -colorAccentGrey -description-padding">You must login to access this feature</p>
      <div>
        <wpbutton type="submit" to="/dashboard/login">Login</wpbutton>
        <wpbutton type="submit" to="/dashboard/create-account">Create a free account</wpbutton>
      </div>
    </div>
  </modal>
</div>
}
